function rdWidgetFooter() {
    var directive = {
        requires: '^rdWidget',
        transclude: true,
        template: '<div class="widget-footer" ng-transclude></div>',
        restrict: 'E'
    };
    return directive;
}

export default function(app){
    app.directive('rdWidgetFooter', rdWidgetFooter)
};
